const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export interface FormattedAge {
  value: number;
  unit: 'second' | 'minute' | 'hour' | 'day';
  i18nKey: string;
}

export function formatAge(timestamp: string | number | Date, now: number = Date.now()): FormattedAge {
  const ts = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  const deltaMs = Math.max(0, now - ts);

  if (deltaMs < MINUTE_MS) {
    return { value: Math.floor(deltaMs / 1000), unit: 'second', i18nKey: 'contentModeration.general.age.seconds' };
  }
  if (deltaMs < HOUR_MS) {
    return { value: Math.floor(deltaMs / MINUTE_MS), unit: 'minute', i18nKey: 'contentModeration.general.age.minutes' };
  }
  if (deltaMs < DAY_MS) {
    return { value: Math.floor(deltaMs / HOUR_MS), unit: 'hour', i18nKey: 'contentModeration.general.age.hours' };
  }
  return { value: Math.floor(deltaMs / DAY_MS), unit: 'day', i18nKey: 'contentModeration.general.age.days' };
}
